import React, { useCallback, useEffect, useState } from 'react';

import { useAppSelector } from 'store/hooks';
import Addr from './Addr';
import NotifyBtn from '../../AccountSetting/Notify/NotifyBtn';
import WalletCollected from './WalletCollected';
import { CheckContainedFill } from 'lib/lucky-x-icons-2';

interface IRegisteredProps {}

const Registered: React.FC<IRegisteredProps> = ({}) => {
  const {
    raffleInfo: { status, type },
  } = useAppSelector((state) => state.raffleDetails);
  const [raffleStatus, setRaffleStatus] = useState('');
  const [raffleType, setRaffleType] = useState('');

  useEffect(() => {
    setRaffleStatus(String(status));
    setRaffleType(String(type));
  }, [status, type]);

  const registerType = useCallback(() => {
    if (raffleType === 'WALLET_COLLECTION') {
      return <WalletCollected />;
    } else {
      return (
        <div>
          <div className="flex flex-col items-center justify-center gap-1 md:flex-row md:justify-center md:gap-3">
            <CheckContainedFill size={24} className="text-primary-500" />
            <div className="text-[22px] font-semibold text-neutral-100 md:text-sm lg:text-lg">
              Registered successfully.
            </div>
          </div>
          {raffleStatus === 'ENDED' && (
            <div className="mt-1 text-center text-sm font-normal text-neutral-300">
              The raffle has ended, and winners will be announced soon.
            </div>
          )}
          <div className="mt-4">
            <Addr />
          </div>
          <NotifyBtn />
        </div>
      );
    }
  }, [raffleStatus, raffleType]);

  return <div>{registerType()}</div>;
};

export default Registered;
